export default __webpack_public_path__ + "static/media/plurato-sailfin-efoil-bw-bars.ac4d1e60.png";